import { Button } from '@wellesley/ui'
import { ArrowRight } from 'lucide-react'
import { NoResults } from '../../../common/components/popover/NoResults'

type SeeMoreResultsOnSearchPageProps = {
  onAllResultsClick: () => void
}

export const SeeMoreResultsOnSearchPage = ({
  onAllResultsClick,
}: SeeMoreResultsOnSearchPageProps) => {
  return (
    <div className="flex items-center gap-xs">
      <div className="flex flex-1">
        <NoResults title="No results found." />
      </div>
      <Button
        size="m"
        variant="secondary"
        onClick={onAllResultsClick}
        className="flex gap-xxs"
      >
        Search page
        <ArrowRight size={20} />
      </Button>
    </div>
  )
}
